import { apiPost } from '../../api'

export const save_diligence = data => {
  return apiPost({
    endpoint: `recruitment/save_diligence`,
    data: data
  })
}
